module.exports = __webpack_public_path__ + "static/Mountain1-93c2cec79cc5a7130f99c8e1e9548743.png";